import { Component, HostBinding, Input, OnInit } from '@angular/core'

@Component({
	selector: 'app-assertive-loader',
	templateUrl: './assertive-loader.component.html',
	styleUrls: ['./assertive-loader.component.scss'],
})
export class AssertiveLoaderComponent implements OnInit {
	@Input() public loadingText: string = 'Fetching...'
	@HostBinding('[attr.role]')
	public _role: string = 'dialog'
	@HostBinding('[attr.aria-live]')
	public _ariaLive: string = 'assertive'
	@HostBinding('[attr.aria-label]')
	public _ariaLabel: string =
		'Loader shown while data is being sent or recieved from the application'
	@HostBinding('[attr.aria-description]')
	public get _ariaDescription(): string {
		return this.loadingText
	}

	constructor() {}

	ngOnInit(): void {}
}
